import classnames from 'classnames';
import { clsx } from 'clsx';
import React, { ReactNode } from 'react';
import './Page.scss';

interface PageProps extends React.ComponentPropsWithoutRef<'div'> {
  banner?: ReactNode;
  flush?: boolean;
  wide?: boolean;
}

function Page({
  className = '',
  id,
  style,
  banner,
  flush,
  wide,
  children,
  ...rest
}: PageProps) {
  return (
    <div className={`${className} Page`} id={id} style={style} {...rest}>
      {banner}
      <div className="container-fluid">
        <div className="row">
          <div
            className={classnames({ flush }, [
              wide ? 'col-sm-12' : 'col-sm-10 col-sm-offset-1'
            ])}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page;

export function FullscreenPage(props: {
  banner?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={clsx('tailwind-root contents', props.className)}>
      <div className="flex flex-col gap-0 h-screen">
        {props.banner}
        <div className="flex-1 min-h-0">{props.children}</div>
      </div>
    </div>
  );
}
